import { cn } from '@/lib/utils';

interface CarryEntityFact {
  label: string;
  value: string;
}

interface CarryEntityHeaderProps {
  kind: string;
  kindClassName?: string;
  title: string;
  description: string;
  facts: CarryEntityFact[];
}

export function CarryEntityHeader({
  kind,
  kindClassName = 'text-muted-foreground',
  title,
  description,
  facts,
}: CarryEntityHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-6 rounded-lg border p-6">
      <div className="max-w-xl">
        <p
          className={cn(
            'text-xs font-medium uppercase tracking-wide',
            kindClassName
          )}
        >
          {kind}
        </p>
        <h2 className="mt-1 text-2xl font-semibold">{title}</h2>
        <p className="mt-2 text-muted-foreground">{description}</p>
      </div>
      <div className="min-w-56 space-y-2">
        {facts.map((fact) => (
          <div key={fact.label} className="flex justify-between gap-6 text-sm">
            <span className="text-muted-foreground">{fact.label}</span>
            <span className="font-medium">{fact.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
